export default "__VITE_ASSET__DBupsU_u__"